import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@tvg/design-system";
// FDR
import { getGeolocationStatus } from "@tvg/sh-geolocation/src/redux/selectors";
import { tryGeolocationRetry } from "@tvg/sh-geolocation/src/redux/actions";
import { setGeoLocationStatusCallback } from "@tvg/sh-geolocation/src/utils/subscriptions";
import { onOpenComplianceModal } from "@tvg/sh-lib-account-wallet/src/utils/mobileUtils";
import { GeolocationStatus } from "@tvg/sh-geolocation/src/types";
import useGeocomplyBetDisabled from "../../../ConfirmBetModal/hooks/useGeocomplyBetDisabled";

const VerifyButton = () => {
  const dispatch = useDispatch();
  const {
    isBetDisabled: isGeoComplyBetDisabled,
    isGeolocationErrorRetryable,
    isGeolocationError
  } = useGeocomplyBetDisabled();
  const geolocationStatus = useSelector(getGeolocationStatus);

  const onRetryVerifyLocation = useCallback(() => {
    dispatch(tryGeolocationRetry(true));
    setGeoLocationStatusCallback(dispatch, GeolocationStatus.PROGRESS);
  }, [isGeolocationError, isGeoComplyBetDisabled, isGeolocationErrorRetryable]);

  if (isGeolocationError && isGeolocationErrorRetryable) {
    return (
      <Button
        ml="space-4"
        variant="betting"
        onPress={onRetryVerifyLocation}
        qaLabel="verify-location-button"
        isLoading={geolocationStatus === GeolocationStatus.PROGRESS}
      >
        Verify location
      </Button>
    );
  }

  return (
    <Button
      ml="space-4"
      variant="betting"
      onPress={onOpenComplianceModal}
      qaLabel="verify-account-button"
    >
      Verify Account
    </Button>
  );
};

export default VerifyButton;
